<script>
export default {
    render(h) {
        const params = {
            row: { ...(this.params.data || {}), _index: this.params.node.rowIndex || 0 },
            index: this.params.rowIndex || 0,
        };
        return this.params.render(h, params);
    },
};
</script>
